import React, { useEffect, useState } from 'react';
import CouponCodeOffer from '../couponCodeOfferForInternets';
import { normalizePlan } from '../couponCodeOfferForInternets/utils';
import request from '../../../utils/request';
import { getProvinceLabel } from '../utils';
import { hasRequiredFiltersForTSB } from '../fibreInternet/utils';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

// Always send English API values regardless of UI locale
const TSB_PLAN_TO_API = {
  [EN.vulcanWebform.vulMonitorTSB]: EN.vulcanWebform.vulMonitorTSB,
  [EN.vulcanWebform.vulProtectTSB]: EN.vulcanWebform.vulProtectTSB,
  [EN.vulcanWebform.vulSmartCameraTSB]: EN.vulcanWebform.vulSmartCameraTSB,
  [FR.vulcanWebform.vulMonitorTSB]: EN.vulcanWebform.vulMonitorTSB,
  [FR.vulcanWebform.vulProtectTSB]: EN.vulcanWebform.vulProtectTSB,
  [FR.vulcanWebform.vulSmartCameraTSB]: EN.vulcanWebform.vulSmartCameraTSB,
};

const index = ({
  setTsbData,
  tsbData,
  orderData,
  tsbTerm,
  setIsFormTouched,
  setShowDownloadQuoteFooter,
  isVulcanFlow,
  selectedTsbPlan
}) => {
  const [couponPage, setCouponPage] = useState(1);
  const [data, setData] = useState({ count: 0, orders: [] });
  const [filters, setFilters] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [searchByOfferCode, setSearchByOfferCode] = useState('');
  const limit = 10;
  const userProfile = JSON.parse(localStorage.getItem('userProfile'));

  const {
    role: { name }
  } = userProfile;

  const payload = {
    province: [getProvinceLabel(orderData)],
    product: ['TSB'],
    term: tsbTerm,
    showExpired: false,
    ...filters
  };

  if (name !== 'ADMIN') {
    payload.salesRepId = orderData.orderCreatedBy.id;
  }

  if (searchByOfferCode) {
    payload.offerCode = searchByOfferCode;
  }

  useEffect(() => {
    if (!hasRequiredFiltersForTSB(filters)) {
      setData({ orders: [], count: 0 });
      return;
    }
    setIsLoading(true);
    const apiTsbPlan = TSB_PLAN_TO_API[selectedTsbPlan] || selectedTsbPlan;
    const tsbPlanQuery = apiTsbPlan ? `&tsbPlan=${encodeURIComponent(apiTsbPlan)}` : '';
    request
      .post(`/offers/filter?page=${couponPage}&limit=${limit}${tsbPlanQuery}`, payload)
      .then(response => {
        setData({ orders: response.data.rows, count: response.data.count });
        setIsLoading(false);
      });
  }, [filters, couponPage, searchByOfferCode, tsbTerm, selectedTsbPlan]);

  return (
    <div>
      <CouponCodeOffer
        data={data}
        setData={setData}
        setCouponPage={setCouponPage}
        couponPage={couponPage}
        setSelectedCouponData={setTsbData}
        selectedCouponData={tsbData}
        setFilters={setFilters}
        filters={filters}
        limit={limit}
        isLoading={isLoading}
        isTSBModal
        isVulcanFlow={isVulcanFlow}
        selectedTsbPlan={normalizePlan(selectedTsbPlan)}
        setSearchByOfferCode={setSearchByOfferCode}
        isButtonDisabled={!tsbTerm}
        setIsFormTouched={setIsFormTouched}
        setShowDownloadQuoteFooter={setShowDownloadQuoteFooter}
      />
    </div>
  );
};

export default index;
